exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ch2-select[data-v-6801e7a4]{position:relative}.ch2-select.show-caret[data-v-6801e7a4]:after{content:\"\";position:absolute;top:20px;right:20px;width:13px;height:8px;background:url(/images/dropdown-closed.svg) no-repeat}.form-control[data-v-6801e7a4]{-webkit-appearance:none;-moz-appearance:none;appearance:none}", ""]);

// exports
